import AWS from 'aws-sdk'
import { CognitoUserPool, CognitoUser, AuthenticationDetails } from 'amazon-cognito-identity-js'
import { cognitoIdentityPoolId, cognitoUserPoolId, cognitoClientId, cognitoRegion } from './aws'
import { initApiGatewayClient, apiGatewayClient } from './api'
import { clearSubscriptions } from './api-catalog'

const poolData = {
  UserPoolId: cognitoUserPoolId,
  ClientId: cognitoClientId
}

let cognitoUser
let userPool

export function isAuthenticated() {
  return cognitoUser
}

function getCognitoLoginKey() {
  return `cognito-idp.${cognitoRegion}.amazonaws.com/${cognitoUserPoolId}`
}

export function init() {
  // attempt to refresh credentials from active session
  userPool = new CognitoUserPool(poolData)
  cognitoUser = userPool.getCurrentUser()

  if (cognitoUser !== null) {
    cognitoUser.getSession(function(err, session) {
      if (err) {
        logout()
        console.error(err)
        return
      }

      const cognitoLoginKey = getCognitoLoginKey()
      const Logins = {}
      Logins[cognitoLoginKey] = session.getIdToken().getJwtToken()
      AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: cognitoIdentityPoolId,
        Logins: Logins
      })

      AWS.config.credentials.refresh((error) => {
        if (error) {
          logout()
          console.error(error)
        } else {
          initApiGatewayClient(AWS.config.credentials)
        }
      })
    })
  } else {
    initApiGatewayClient()
    // if (!/index\.html/.test(window.location.href)) {
    //   // window.location = 'index.html'
    //   return
    // } else {
    //   window.localStorage.removeItem('aws.cognito.identity-id.' + cognitoIdentityPoolId)
    //   window.localStorage.removeItem('aws.cognito.identity-providers.' + cognitoIdentityPoolId)
    // }
  }
}

export function register(email, password, application) {
  localStorage.clear()
  const attributeList = [{
    Name : "custom:application",
    Value : application
  }]
  return new Promise((resolve, reject) => {
    userPool.signUp(email, password, attributeList, null, (err, result) => {
      if (err) {
        reject(err)
      } else {
        SendEmail(email)
        resolve()
      }
    })
  })
}

function SendEmail(username) {
  var details = {
    Destination: {
      ToAddresses: [
        'elabetoria@asianhospital.com'
      ]
    },
    Message: {
      Body: {
        Html: {
          Charset: "UTF-8",
          Data: "<b style=\"font-size:'15px'\">Account Registration</b><br/><br/>Good Day!<br/>An account has just been created in <a href=\"https://developer.hopprlab.com\">hopprLab for developers</a>. Please confirm the user account of <b></b> in the <a href=\"https://asianhospital.signin.aws.amazon.com/console\">AWS Console</a>.<br/><br/><i>User Email: </i>" + username 
        },
      },
      Subject: {
        Charset: "UTF-8",
        Data: "API User Account Confirmation"
      }
    },
    Source: 'no-reply@hopprlab.com'
  };
  var sendPromise = new AWS.SES({apiVersion: '2010-12-01', accessKeyId: 'AKIAIXL2QWICOV34GSYQ', secretAccessKey: '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', sslEnabled: true}).sendEmail(details).promise();

  sendPromise.then(function(data) {
    console.log(data);
  }).catch(
    function(err) {
      console.error(err, err.stack);
    }
  );
}

{/*function disableUser(email) {
  const userDetails = {
    Username: email,
    UserPoolId: cognitoUserPoolId
  };

  return new Promise((resolve, reject) => {
    cognitoUser.adminDisableUser(userDetails, (err, result) => {
      if (err) {
        reject(err)
      }
      else {
        console.log("user is disabled");
      }
    })
  })
}*/}

export function login(email, password) {
    const authenticationData = {
      Username: email,
      Password: password
    }
    const authenticationDetails = new AuthenticationDetails(authenticationData)
    userPool = new CognitoUserPool(poolData)
    const userData = {
      Username: email,
      Pool: userPool
    }

    cognitoUser = new CognitoUser(userData)
    return new Promise((resolve, reject) => {
      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: (result) => {
          // cognitoUser = result.user
          console.log('access token + ' + result.getAccessToken().getJwtToken())
          console.log(result);
          const cognitoLoginKey = getCognitoLoginKey()
          const Logins = {}
          Logins[cognitoLoginKey] = result.getIdToken().getJwtToken()
          AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: cognitoIdentityPoolId,
            Logins: Logins
          })

          AWS.config.credentials.refresh((error) => {
            if (error) {
              console.error(error)
            } else {
              console.log('Successfully logged in')

              initApiGatewayClient(AWS.config.credentials)

              apiGatewayClient.post('/signin', {}, {}, {}).then((result) => {
                resolve(result)
              }).catch((err) => {
                reject(err)
              })
            }
          })
        },

        onFailure: (err) => {
          reject(err)
        }
    })
  })
}

export function logout() {
  cognitoUser.signOut()
  cognitoUser = null
  clearSubscriptions()
  localStorage.clear()
}

export function showApiKey() {
  return apiGatewayClient.get('/apikey', {}, {}, {}).then(({data}) => data.value)
}



/** WEBPACK FOOTER **
 ** ./src/services/self.js
 **/